/* eslint-disable consistent-return */
import {
    BehaviorSubject,
    EMPTY,
    concat,
    empty,
    from,
    interval,
    merge,
    of,
    timer,
} from "rxjs";
import {
    catchError,
    endWith,
    exhaustMap,
    filter,
    flatMap,
    map,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";
import { Auth } from "@pacificoseguros/tools";
import { ofType } from "redux-observable";
import {
    ADD_RECOMMENDED_COVERAGES,
    CALCULATE_HOME_PRICE,
    CALCULATE_TOTAL_PRICE,
    DISABLE_DEPENDENT_COVERAGES,
    DO_PAYMENT,
    GO_NEXT_STEP,
    INITIALIZE_QUOTATION_FLOW,
    LOAD_CHANNEL,
    LOAD_UBIGEOS,
    SAVE_GUESS_PRICE,
    SAVE_HOUSING_INFO,
    SAVE_PERSONAL_DATA,
    SAVE_PLAN_CUSTOM,
    SEE_MORE_IN_LANDING,
    SEND_ZOHO,
    SET_FIXED_PLAN_SELECTION,
    START_QUOTE_PROCESS,
    TOGGLE_ASSISTANT_PACKAGE,
    TOGGLE_SELECTED_COVERAGE,
    VALIDATE_IF_DOCUMENT_NUMBER_EXISTS,
    VALIDATE_MIN_PRIME,
    calculateHomePriceDone,
    disableDependentCoverages,
    disableDependentCoveragesDone,
    doPaymentDone,
    initializeQuotationFlowDone,
    loadChannelDone,
    saveGuessPrice,
    saveGuessPriceDone,
    saveHousingInfoDone,
    savePersonalData,
    savePersonalDataDone,
    savePlanCustomDone,
    sendZoho,
    sendZohoDone,
    setFixedPlanSelection,
    setReferentialValue,
    setUbigeos,
    startQuoteProcess,
    startQuoteProcessDone,
    toggleAssistantPackage,
    toggleSelectedCoverage,
    updateAssetsValue,
    updateQuotationPrice,
    updateRecommendedCoverages,
    updateZohoDone,
    updateCrmDone,
    validateIfDocumentNumberExistsDone,
    validateMinPrime,
    SAVE_INITIAL_HOUSE_INFORMATION,
    TOGGLE_SELECTED_MULTIPLE_COVERAGES,
    SEND_CRM_ORACLE_GET_CUSTOMER,
    SEND_CRM_ORACLE_CREATE_CUSTOMER,
    SEND_CRM_ORACLE_CREATE_OPPORTUNITY,
    updateCrmOracle,
    updateCrmOracleOptyNumber,
    sendCrmOracleCreateCustomer,
    sendCrmOracleCreateOpportunity,
    UPDATE_CRM_ORACLE_INITIAL_DATA,
    UPDATE_CRM_ORACLE_QUOTE,
    UPDATE_CRM_ORACLE_DATA,
    UPDATE_CRM_ORACLE_PAYMENT,
    UPDATE_CRM_ORACLE_END,
    updateCrmOracleInitialData,
    updateCrmOracleQuote,
    updateCrmOracleData,
    updateCrmOraclePayment,
} from "./home-insurance.actions";
import {
    COVERAGES_CODES,
    COVERAGES_DEPENDENCY,
    FIXED_COVERAGES_LIST,
} from "../../constants/coverages";
import {
    FIXED_PLAN_ANNUAL_PLANS_BY_WHICH_ENSURE,
    FIXED_PLAN_HOUSING_ASSETS_MONTHLY_AMOUNTS_COMBINATIONS,
} from "../../constants/plans";
import {
    OWNER_LIVE_FIXED_PLAN_COVERAGE_BOXES,
    OWNER_RENT_FIXED_PLAN_COVERAGE_BOXES,
    ROOMER_FIXED_PLAN_COVERAGE_BOXES,
} from "../../constants/coverages-boxes";
import { PARTNER_NAME, PARTNER_TYPE } from "../../constants/datalayer";
import {
    PLAN_TYPES,
    WHICHENSURE_TYPES,
    ZOHO_MASKED_SURNAME,
} from "../../constants/personaldata";
import {
    closeQuotePopup,
    hideLoading,
    loadDefaultChannelDone,
    navigateTo,
    openAppModal,
    showLoading,
} from "../page/page.actions";
import { ensureAssets, ensureHousing } from "../../libs/helpers/housing";
import { getTierForAssetsValue, getTierForHousingValue } from "../../libs/helpers/price";
import {
    mapEstimatedResponseToCoverages,
    mapHomeInsuraceStateToEstimatedSelectionsRequest,
    mapSaveSelectedCoveragesResponseToPriceAndFees,
} from "../../libs/helpers/mappers";

import Api from "../../api/api";
import { BUILDING_MATERIALS_LABELS } from "../../constants/housing";
import ChannelApi from "../../api/channel-api";
import Datalayer from "../../libs/vendors/data-layer";
import { ENV } from "../../constants/env";
import { HomeInsuranceApi } from "../../api/home-insurance.api";
import { InitialQuotation } from "../../models/initial-quote";
import { MONTHLY_MIN_PRIME_PRICE } from "../../constants/prices";
import { NOT_FOUND_LOCATION_CODE } from "../../constants/error-codes";
import { Opportunity } from "../../models";
import { PersonalDataInfo } from "../../models/personal-data-info";
import ROUTES from "../../constants/routes";
import { Ubigeo } from "../../models/ubigeo";
import ZohoApi from "../../api/zoho-api";
import { filterCoveragesByEnsuredType } from "../../libs/helpers/coverages";
import { getPathWithPartner } from "../../containers/home-insurance/home-insurance.routes";
import { isEnableProperty } from "../../libs/helpers/object";
import { isNull } from "../../libs/helpers/regex";
import { setError } from "../app/app.action";
import CrmOracleApi from "../../api/crm-oracle";
import { CreateCustomerCrmOracle } from "../../models/create-customer-crm-oracle";
import { CreateOpportunityCrmOracle } from "../../models/create-opportunity-crm-oracle";
import {
    clientTypeTranslate,
    ensureTranslate,
    formatDateToCrmOracle,
    getIdDocumentType,
    housingTypeTranslate,
} from "../../libs/helpers/util";
import {
    UpdateDataPhase,
    UpdateEndPhase,
    UpdateInitialDataPhase,
    UpdatePaymentPhase,
    UpdateQuotePhase,
} from "../../models/update-phase-crm-oracle";

const initializeQuotationFlowEpic = (action$, store) =>
    action$.pipe(
        ofType(INITIALIZE_QUOTATION_FLOW),
        switchMap(({ payload = new InitialQuotation() }) => {
            const _channel = Datalayer.partner ? Datalayer.partner.toUpperCase() : null;
            const _channelToSend =
                _channel &&
                    _channel !== PARTNER_NAME.callcenter &&
                    _channel !== PARTNER_NAME.default
                    ? _channel
                    : null;
            const body = {
                documentId: String(payload.documentNumber).padStart(8, "0"),
                email: payload.email,
                mobile: payload.cellphone,
                documentType: payload.documentType,
                recaptchaToken: payload.recaptchaToken,
                channel: _channelToSend,
            };
            const { clientType, whichEnsure, housingType } = payload;
            const { partyId } = store.value.HomeInsurance.crmOracle;
            if (Number(ENV.REACT_APP_IS_A_FORM) === 1) {
                return concat(
                    partyId
                        ? of(sendCrmOracleCreateOpportunity(payload))
                        : of(sendCrmOracleCreateCustomer(payload))
                );
            }
            return HomeInsuranceApi.createRequest({
                ...body,
            }).pipe(
                tap(() => {
                    window.dynatraceParams = {
                        userDocument: `${payload.documentType}-${payload.documentNumber}`,
                    };
                }),
                tap(({ xhr }) => {
                    Api.authorization = xhr.getResponseHeader("authorization");
                }),
                tap(ajaxResponse => {
                    Datalayer.setTransactionId(ajaxResponse.response.requestId);
                }),
                flatMap(({ response }) => {
                    const {
                        documentNumberValidation,
                        data,
                    } = store.value.HomeInsurance.quotation.initialQuotationForm;
                    const { requestId } = response;

                    const dataForCrm = {
                        ...{ response },
                        isCreate: true,
                        ...data,
                        channel: _channelToSend,
                        clientType,
                        whichEnsure,
                        housingType,
                    };
                    return concat(
                        !isEnableProperty(ENV.SHOW_PERSONAL_DATA_CONSENT_AT_PAYMENT_PAGE)
                            ? HomeInsuranceApi.savePersonalDatConsent({
                                requestId,
                            }).pipe(switchMap(() => EMPTY))
                            : EMPTY,

                        HomeInsuranceApi.saveContactConsent({
                            requestId,
                            contactConsent: payload.contactConsent,
                        }).pipe(switchMap(() => EMPTY)),
                        of(
                            initializeQuotationFlowDone({
                                ...response,
                                clientType,
                                whichEnsure,
                                housingType,
                            })
                        ),
                        of(
                            savePersonalData({
                                ...new PersonalDataInfo({
                                    clientType,
                                    whichEnsure,
                                    housingType,
                                }),
                                requestId,
                            })
                        ),

                        documentNumberValidation.exists
                            ? EMPTY
                            : HomeInsuranceApi.updateCustomerInfo({
                                requestId,
                                birthDate: data.birthDate,
                                firstSurname: data.firstSurname,
                                lastSurname: data.lastSurname,
                                names: data.names,
                            }).pipe(switchMap(() => EMPTY)),

                        partyId
                            ? of(sendCrmOracleCreateOpportunity(dataForCrm))
                            : of(sendCrmOracleCreateCustomer(dataForCrm)),

                        of(
                            sendZoho({
                                ...{ response },
                                isCreate: true,
                                ...data,
                                channel: _channelToSend,
                                clientType,
                                whichEnsure,
                                housingType,
                            })
                        ),
                        of(
                            navigateTo(
                                getPathWithPartner(
                                    ROUTES.HOME_INSURANCE.STEP2,
                                    store.value.HomeInsurance.channel.partner,
                                    store.value.HomeInsurance.channel.partnerType
                                )
                            )
                        ),
                        of(closeQuotePopup())
                    );
                }),
                catchError(err => of(initializeQuotationFlowDone(err)))
            );
        })
    );

const sendZohoEpic = (action$, store) =>
    action$.pipe(
        ofType(SEND_ZOHO),
        switchMap(({ payload }) => {
            if (
                Datalayer.partnerType === PARTNER_TYPE.company ||
                Datalayer.partnerType === PARTNER_TYPE.mibanco
            ) {
                return EMPTY;
            }
            if (!payload.isCreate) {
                return ZohoApi.addUpdate(
                    {
                        ...payload.info,
                    },
                    store.value.HomeInsurance.channel.idZoho,
                    Auth.getAuthorization()
                ).pipe(
                    flatMap(() => of(updateZohoDone())),
                    catchError(() => EMPTY)
                );
            }
            const {
                Page: { queryString },
                HomeInsurance: {
                    quotation,
                    channel: { partner },
                },
            } = store.value;
            const { exists } = quotation.initialQuotationForm.documentNumberValidation;
            const {
                response: { customer, requestId },
                clientType,
                whichEnsure,
                housingType,
                contactConsent,
            } = payload;
            const names = exists ? customer.names : payload.names;
            const surname = exists ? ZOHO_MASKED_SURNAME : payload.firstSurname;
            return ZohoApi.add(
                new Opportunity({
                    names,
                    surname,
                    email: isNull(customer.email, payload.email),
                    cellphone: isNull(customer.cellphone, payload.cellphone),
                    documentNumber: isNull(
                        customer.documentNumber,
                        payload.documentNumber
                    ),
                    channel: ZohoApi.validateChannel(partner),
                    from: queryString || "",
                    requestId,
                    clientType,
                    whichEnsure,
                    housingType,
                    contactConsent,
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(zohoResponse =>
                    concat(
                        of(
                            sendZohoDone({
                                ...zohoResponse.response,
                            })
                        ),
                        HomeInsuranceApi.updateUserPotencialId({
                            requestId: store.value.HomeInsurance.quotation.requestId,
                            potencialId: zohoResponse.response.zohoId,
                        }).pipe(flatMap(() => EMPTY))
                    )
                ),
                catchError(() => EMPTY)
            );
        })
    );

const savePersonalDataEpic = action$ =>
    action$.pipe(
        ofType(SAVE_PERSONAL_DATA),
        switchMap(({ payload }) => {
            const { requestId, clientType, whichEnsure, planType } = payload;
            return HomeInsuranceApi.updatePersonalData({
                requestId,
                clientType,
                insuranceType: whichEnsure,
                planType,
            }).pipe(
                flatMap(() => of(savePersonalDataDone())),
                catchError(err => of(savePersonalDataDone(err)))
            );
        })
    );

const saveHousingInfoEpic = (action$, store) =>
    action$.pipe(
        ofType(SAVE_HOUSING_INFO),
        switchMap(({ payload }) => {
            const {
                location,
                squareMeters,
                address,
                housingAge,
                interiorNumber,
                hasStores,
                floorsNumber,
                basements,
                buildingMaterial,
            } = payload;
            const {
                HomeInsurance: { quotation },
            } = store.value;
            const [district] = location.label.split("|");

            return HomeInsuranceApi.saveHousing({
                requestId: quotation.requestId,
                housingInfo: payload,
            }).pipe(
                switchMap(() => {
                    const sendZoho$ = of(
                        sendZoho({
                            info: {
                                fase: "datos inmueble",
                                distrito: district.trim(),
                                direccion: address,
                                material:
                                    BUILDING_MATERIALS_LABELS[buildingMaterial] || "",
                                anios: housingAge,
                                metros: String(squareMeters),
                                dpto: interiorNumber || "0",
                                marcaDeposito: hasStores ? "SI" : "NO",
                                numeroPisos: String(floorsNumber),
                                numeroSotanos: basements || "0",
                            },
                            isCreate: false,
                        })
                    );
                    const updateCrmOracleData$ = of(
                        updateCrmOracleData({
                            info: {
                                fase: "datos_inmueble",
                                anios: housingAge,
                                numeroPisos: String(floorsNumber),
                                numeroSotanos: basements || "0",
                                material:
                                    BUILDING_MATERIALS_LABELS[buildingMaterial] || "",
                                direccion: address,
                                dpto: interiorNumber || "0",
                            },
                        })
                    );
                    return concat(
                        of(saveHousingInfoDone()),
                        sendZoho$,
                        updateCrmOracleData$,
                        of(startQuoteProcess())
                    );
                }),
                catchError(err => of(saveHousingInfoDone(err)))
            );
        })
    );

const saveInitialHouseInformationEpic = action$ =>
    action$.pipe(
        ofType(SAVE_INITIAL_HOUSE_INFORMATION),
        switchMap(({ payload }) => {
            const { location, housingType, squareMeters } = payload;
            const [district, department, province] = location.label.split("|");

            return HomeInsuranceApi.calculateHomePrice({
                locationId: location.value,
                propertyType: housingType,
                squareMeter: squareMeters,
            }).pipe(
                map(({ response }) => setReferentialValue(response)),
                switchMap(calculateAction => {
                    const hasErrorCalculate = calculateAction.error;
                    const allIsOk =
                        !hasErrorCalculate ||
                        calculateAction.payload.status === NOT_FOUND_LOCATION_CODE;

                    const housingValue = !hasErrorCalculate ? calculateAction.payload : 0;
                    const saveGuessPrice$ = allIsOk
                        ? of(
                            saveGuessPrice({
                                assetValue: 0,
                                housingValue,
                            })
                        )
                        : EMPTY;
                    const sendZoho$ = of(
                        sendZoho({
                            info: {
                                fase: "datos iniciales inmueble",
                                distrito: district.trim(),
                                metros: String(squareMeters),
                            },
                            isCreate: false,
                        })
                    );
                    const updateCrmOracleInitialData$ = of(
                        updateCrmOracleInitialData({
                            info: {
                                fase: "datos_iniciales_inmueble",
                                distrito: district.trim(),
                                provincia: province.trim(),
                                departamento: department.trim(),
                                metros: String(squareMeters),
                            },
                        })
                    );
                    return concat(
                        of(calculateAction),
                        updateCrmOracleInitialData$,
                        sendZoho$,
                        saveGuessPrice$
                    );
                }),
                catchError(err => {
                    const setReferentialValue$ = of(setReferentialValue(err));
                    const saveGuessPrice$ = of(
                        saveGuessPrice({
                            assetValue: 0,
                            housingValue: 0,
                        })
                    );
                    return concat(setReferentialValue$, saveGuessPrice$);
                })
            );
        })
    );

const startQuoteProcessEpic$ = (action$, store) =>
    action$.pipe(
        ofType(START_QUOTE_PROCESS),
        exhaustMap(() => {
            const { quotation, channel } = store.value.HomeInsurance;
            const {
                data: { assetValue, housingValue },
            } = quotation.guessPriceForm;
            return concat(
                HomeInsuranceApi.startQuote({
                    requestId: quotation.requestId,
                }).pipe(
                    flatMap(() => {
                        const timer$ = timer(ENV.QUOTE.MAX_SECONDS);
                        const policyStatusDone$ = new BehaviorSubject(null);
                        const stopInterval$ = merge(
                            timer$,
                            policyStatusDone$.pipe(filter(value => value !== null))
                        );
                        const navigation$ = of(
                            navigateTo(
                                getPathWithPartner(
                                    ROUTES.HOME_INSURANCE.STEP5,
                                    channel.partner,
                                    channel.partnerType
                                )
                            )
                        );
                        const sendZoho$ = quotationNumber =>
                            of(
                                sendZoho({
                                    info: {
                                        fase: "cotizacion",
                                        monto: String(quotation.price.toFixed(2)),
                                        valorBien: String(assetValue || 0),
                                        valorInmueble: String(housingValue || 0),
                                        endoso: "No",
                                        entidad: "Ninguno",
                                        montoEndosar: "0",
                                        ot: quotationNumber,
                                    },
                                    isCreate: false,
                                })
                            );
                        return interval(ENV.QUOTE.INTERVAL_SECONDS).pipe(
                            takeUntil(stopInterval$),
                            endWith(-1),
                            flatMap(intervalValue => {
                                if (
                                    intervalValue === -1 &&
                                    policyStatusDone$.value === null
                                ) {
                                    return of({
                                        policyStatus: "DOING",
                                        isFinished: true,
                                    });
                                }

                                return HomeInsuranceApi.verifyQuoteStatus({
                                    requestId: quotation.requestId,
                                }).pipe(
                                    map(({ response }) => {
                                        const done = response.policyStatus === "DONE";
                                        const hasError =
                                            response.policyStatus === "ERROR";
                                        if (done) {
                                            policyStatusDone$.next(true);
                                        }
                                        if (hasError) {
                                            policyStatusDone$.next(false);
                                        }
                                        return {
                                            done,
                                            quotationNumber: response.numeroCotizacion,
                                            policyStatus: response.policyStatus,
                                        };
                                    })
                                );
                            }),
                            flatMap(
                                ({ done, quotationNumber, policyStatus, isFinished }) => {
                                    if (done) {
                                        return concat(
                                            navigation$,
                                            sendZoho$(quotationNumber)
                                        );
                                    }

                                    if (policyStatus === "ERROR") {
                                        return of(
                                            openAppModal({ type: "service-error" })
                                        );
                                    }

                                    if (policyStatus === "DOING" && isFinished) {
                                        return of(
                                            openAppModal({
                                                type: "timeout-error",
                                                showActionButton: true,
                                                actionType: START_QUOTE_PROCESS,
                                            })
                                        );
                                    }

                                    return EMPTY;
                                }
                            )
                        );
                    }),
                    catchError(err => {
                        const { status, message } = err;
                        return of(
                            setError({ status, message, actionType: START_QUOTE_PROCESS })
                        );
                    })
                ),
                of(hideLoading()),
                of(startQuoteProcessDone())
            );
        })
    );

const saveGuessPriceEpic$ = (action$, store) =>
    action$.pipe(
        ofType(SAVE_GUESS_PRICE),
        switchMap(({ payload }) => {
            const {
                quotation: { guessPriceForm, personalDataForm, requestId },
                channel,
            } = store.value.HomeInsurance;
            const { whichEnsure } = personalDataForm.data;
            const { housingValue, assetValue, currency } = guessPriceForm.data;

            const estimatedBelongingsAmount = !payload.update
                ? payload.assetValue
                : assetValue;

            const estimatedPropertyAmount = !payload.update
                ? payload.housingValue
                : housingValue;
            return HomeInsuranceApi.createEstimated({
                requestId,
                currency,
                estimatedBelongingsAmount: Number(estimatedBelongingsAmount || 0),
                estimatedPropertyAmount: Number(estimatedPropertyAmount || 0),
            }).pipe(
                flatMap(({ response }) => {
                    const mappedResponse = mapEstimatedResponseToCoverages(response);
                    mappedResponse.coverages = filterCoveragesByEnsuredType(
                        mappedResponse.coverages,
                        whichEnsure
                    );
                    if (
                        ensureHousing(whichEnsure) &&
                        getTierForHousingValue(housingValue) < 3
                    ) {
                        mappedResponse.propertyInsuranceHasMinPrime = true;
                    }

                    mappedResponse.belongingsInsuranceHasMinPrime = ensureAssets(
                        whichEnsure
                    );

                    const updateAssetsValue$ = !payload.update
                        ? of(updateAssetsValue())
                        : EMPTY;

                    const navigate$ = !payload.update
                        ? of(
                            navigateTo(
                                getPathWithPartner(
                                    ROUTES.HOME_INSURANCE.STEP3,
                                    channel.partner,
                                    channel.partnerType
                                )
                            )
                        )
                        : EMPTY;

                    return concat(
                        of(saveGuessPriceDone(mappedResponse)),
                        of(
                            setFixedPlanSelection({
                                declaredBelongingsAmount: null,
                                declaredPropertyAmount: null,
                            })
                        ),
                        of(validateMinPrime()),
                        updateAssetsValue$,
                        navigate$
                    );
                }),
                catchError(err => of(saveGuessPriceDone(err)))
            );
        })
    );

const calculatePriceEpic = (action$, store) =>
    action$.pipe(
        ofType(
            TOGGLE_SELECTED_COVERAGE,
            TOGGLE_SELECTED_MULTIPLE_COVERAGES,
            TOGGLE_ASSISTANT_PACKAGE,
            CALCULATE_TOTAL_PRICE,
            SET_FIXED_PLAN_SELECTION
        ),
        switchMap(() => {
            const {
                mainCoverage,
                selectedCoverages,
                assistantPackage,
                personalDataForm: {
                    data: { planType },
                },
            } = store.value.HomeInsurance.quotation;
            if (planType === PLAN_TYPES.CUSTOM) {
                const coveragesRelatedToMainPrime = selectedCoverages
                    .filter(
                        cov =>
                            cov.code !== COVERAGES_CODES.ROBBERY &&
                            cov.code !== COVERAGES_CODES.DISAPPEAR &&
                            cov.code !== COVERAGES_CODES.THEFT_ESPECIAL &&
                            cov.code !== COVERAGES_CODES.DISHONESTY
                    )
                    .concat([mainCoverage])
                    .concat(assistantPackage ? [assistantPackage] : []);
                const coveragesRelatedToRobberyPrime = selectedCoverages.filter(
                    cov =>
                        cov.code === COVERAGES_CODES.ROBBERY ||
                        cov.code === COVERAGES_CODES.DISAPPEAR ||
                        cov.code === COVERAGES_CODES.THEFT_ESPECIAL ||
                        cov.code === COVERAGES_CODES.DISHONESTY
                );
                const robberyPrimeMustBeAdded =
                    coveragesRelatedToRobberyPrime.length >= 1;
                const mainPrimeSum = coveragesRelatedToMainPrime.reduce(
                    (sum, cov) => sum + cov.monthlyPrice,
                    0
                );
                const fixedMainPrimeSum = Math.max(mainPrimeSum, MONTHLY_MIN_PRIME_PRICE);
                const robberyPrimeSum =
                    robberyPrimeMustBeAdded &&
                    Math.max(
                        coveragesRelatedToRobberyPrime.reduce(
                            (sum, cov) => sum + cov.monthlyPrice,
                            0
                        ),
                        MONTHLY_MIN_PRIME_PRICE
                    );
                const newPrice = fixedMainPrimeSum + robberyPrimeSum;
                return of(
                    updateQuotationPrice({
                        price: newPrice,
                        mainPrimeSum,
                        hasMainPrimeMinPrime: mainPrimeSum < fixedMainPrimeSum,
                    })
                );
            }
            const {
                personalDataForm: {
                    data: { whichEnsure },
                },
                customPlanView: {
                    fixedPlan: { declaredBelongingsAmount, declaredPropertyAmount },
                },
            } = store.value.HomeInsurance.quotation;
            const belongingsPlan = FIXED_PLAN_ANNUAL_PLANS_BY_WHICH_ENSURE[
                WHICHENSURE_TYPES.ASSETS
            ].find(plan => plan.annualAmount === declaredBelongingsAmount);
            const belongingsPlanMonthlyAmount = belongingsPlan
                ? belongingsPlan.monthlyAmount
                : 0;
            const propertyPlan = FIXED_PLAN_ANNUAL_PLANS_BY_WHICH_ENSURE[
                WHICHENSURE_TYPES.HOUSING
            ].find(plan => plan.annualAmount === declaredPropertyAmount);
            const propertyPlanMonthlyAmount = propertyPlan
                ? propertyPlan.monthlyAmount
                : 0;
            let price = 0;
            switch (whichEnsure) {
                case WHICHENSURE_TYPES.HOUSING:
                    price = propertyPlanMonthlyAmount;
                    break;
                case WHICHENSURE_TYPES.ASSETS:
                    price = belongingsPlanMonthlyAmount;
                    break;
                case WHICHENSURE_TYPES.HOUSING_ASSETS: {
                    const combination = FIXED_PLAN_HOUSING_ASSETS_MONTHLY_AMOUNTS_COMBINATIONS.find(
                        comb =>
                            comb.housingAnnualAmount === declaredPropertyAmount &&
                            comb.assetsAnnualAmount === declaredBelongingsAmount
                    );
                    price = combination ? combination.housingAssetsMonthlyAmount : 0;
                    break;
                }
                default:
                    break;
            }
            return of(
                updateQuotationPrice({
                    price,
                    mainPrim: 0,
                    hasMainPrimeMinPrime: null,
                })
            );
        })
    );

const addRecommendedCoveragesEpic = (action$, store) =>
    action$.pipe(
        ofType(ADD_RECOMMENDED_COVERAGES),
        switchMap(() => {
            const toggleCoveragesSelection$List = [];
            const {
                coverages,
                fixedCoverages,
                quotation: { selectedCoverages },
            } = store.value.HomeInsurance;
            const _coveragesToAdd = FIXED_COVERAGES_LIST;
            const _coverages = [...coverages, ...fixedCoverages];
            _coveragesToAdd.forEach(coverageCode => {
                const coverageToAdd = _coverages.find(c => c.code === coverageCode);
                if (
                    !!coverageToAdd &&
                    !selectedCoverages.find(c => c.id === coverageToAdd.id)
                ) {
                    toggleCoveragesSelection$List.push(
                        of(
                            toggleSelectedCoverage({
                                coverage: coverageToAdd,
                                selected: true,
                            })
                        )
                    );
                }
            });
            toggleCoveragesSelection$List.push(
                of(
                    updateRecommendedCoverages({
                        addedToList: true,
                    })
                )
            );
            return concat(...toggleCoveragesSelection$List);
        })
    );

const saveSelectedPlanEpic$ = (action$, store) =>
    action$.pipe(
        ofType(SAVE_PLAN_CUSTOM),
        switchMap(({ payload }) => {
            const {
                personalDataForm: {
                    data: { whichEnsure, planType },
                },
                guessPriceForm: {
                    data: { currency, assetValue, housingValue },
                },
                customPlanView: {
                    fixedPlan: { declaredBelongingsAmount, declaredPropertyAmount },
                },
            } = store.value.HomeInsurance.quotation;
            const { channel } = store.value.HomeInsurance;
            let fixedPlanCoveragesCodes = [];
            // eslint-disable-next-line default-case
            switch (whichEnsure) {
                case WHICHENSURE_TYPES.HOUSING:
                    fixedPlanCoveragesCodes = [
                        COVERAGES_CODES.PRIME,
                        ...OWNER_RENT_FIXED_PLAN_COVERAGE_BOXES,
                    ];
                    break;
                case WHICHENSURE_TYPES.ASSETS:
                    fixedPlanCoveragesCodes = [
                        COVERAGES_CODES.PRIME,
                        ...ROOMER_FIXED_PLAN_COVERAGE_BOXES,
                    ];
                    break;
                case WHICHENSURE_TYPES.HOUSING_ASSETS:
                    fixedPlanCoveragesCodes = [
                        COVERAGES_CODES.PRIME,
                        ...OWNER_LIVE_FIXED_PLAN_COVERAGE_BOXES,
                    ];
                    break;
            }
            return concat(
                of(showLoading("Ya falta poco...")),
                HomeInsuranceApi.saveStartEnsureDate({
                    requestId: store.value.HomeInsurance.quotation.requestId,
                    startEnstureDate: payload.startEnsureDate,
                }).pipe(
                    switchMap(() => {
                        return HomeInsuranceApi.createEstimated({
                            requestId: store.value.HomeInsurance.quotation.requestId,
                            currency,
                            estimatedBelongingsAmount: Number(assetValue || 0),
                            estimatedPropertyAmount: Number(housingValue || 0),
                            declaredBelongingsAmount,
                            declaredPropertyAmount,
                        })
                            .pipe(
                                switchMap(() =>
                                    HomeInsuranceApi.saveSelectedCoverages({
                                        requestId:
                                            store.value.HomeInsurance.quotation.requestId,
                                        selectedCoveragesCodes:
                                            planType === PLAN_TYPES.CUSTOM
                                                ? mapHomeInsuraceStateToEstimatedSelectionsRequest(
                                                    store.value.HomeInsurance
                                                )
                                                : fixedPlanCoveragesCodes,
                                    })
                                )
                            )
                            .pipe(
                                flatMap(saveSelectedCoveragesResp =>
                                    concat(
                                        of(
                                            savePlanCustomDone(
                                                mapSaveSelectedCoveragesResponseToPriceAndFees(
                                                    saveSelectedCoveragesResp.response
                                                )
                                            )
                                        ),
                                        of(
                                            navigateTo(
                                                getPathWithPartner(
                                                    ROUTES.HOME_INSURANCE.STEP4,
                                                    channel.partner,
                                                    channel.partnerType
                                                )
                                            )
                                        ),
                                        of(
                                            updateCrmOracleQuote({
                                                info: {
                                                    fase: "cotizacion",
                                                    valorBien: String(assetValue || 0),
                                                    valorInmueble: String(
                                                        housingValue || 0
                                                    ),
                                                    fechaInicio: payload.startEnsureDate,
                                                },
                                                isCreate: false,
                                            })
                                        )
                                    )
                                ),
                                catchError(err =>
                                    concat(of(savePlanCustomDone(err)), of(hideLoading()))
                                )
                            );
                    }),
                    catchError(error =>
                        concat(of(savePlanCustomDone(error)), of(hideLoading()))
                    )
                )
            );
        })
    );


const loadUbigeosEpic = (action$, store) =>
    action$.pipe(
        ofType(LOAD_UBIGEOS),
        switchMap(() => {
            if (store.value.HomeInsurance.ubigeos) {
                return empty();
            }
            return HomeInsuranceApi.getUbigeos().pipe(
                map(({ response = [] }) =>
                    setUbigeos(response.map(ub => new Ubigeo(ub)))
                ),
                catchError(() => of(setUbigeos([])))
            );
        })
    );

const nextStepEpic = (action$, store) =>
    action$.pipe(
        ofType(GO_NEXT_STEP),
        switchMap(() => {
            return of(
                navigateTo(
                    getPathWithPartner(
                        ROUTES.HOME_INSURANCE.STEP2,
                        store.value.HomeInsurance.channel.partner,
                        store.value.HomeInsurance.channel.partnerType
                    )
                )
            );
        })
    );

const calculateHomePriceEpic = action$ =>
    action$.pipe(
        ofType(CALCULATE_HOME_PRICE),
        switchMap(({ payload }) =>
            HomeInsuranceApi.calculateHomePrice({
                locationId: payload.location,
                propertyType: payload.housingType,
                squareMeter: payload.squareMeters,
            }).pipe(
                flatMap(({ response }) =>
                    of(calculateHomePriceDone({ response, form: payload }))
                ),
                catchError(err => {
                    const newError =
                        err.status === NOT_FOUND_LOCATION_CODE
                            ? Object.assign(err, {
                                location: payload.location,
                                squareMeters: payload.squareMeters,
                                housingType: payload.housingType,
                                increment: 1,
                            })
                            : Object.assign(err, {
                                location: null,
                                squareMeters: null,
                                housingType: null,
                                increment: 0,
                            });
                    return of(calculateHomePriceDone(newError));
                })
            )
        )
    );

const seeMoreInLandingEpic = action$ =>
    action$.pipe(
        ofType(SEE_MORE_IN_LANDING),
        flatMap(() => {
            const targetElm = document.querySelector(".landing-which-ensure");
            if (targetElm) {
                targetElm.scrollIntoView({ behavior: "smooth" });
            }
            return empty();
        })
    );

const deselectDependentCoveragesEpic = (action$, store) =>
    action$.pipe(
        ofType(TOGGLE_SELECTED_COVERAGE),
        flatMap(({ payload: { coverage, selected } }) => {
            const {
                quotation: {
                    personalDataForm: {
                        data: { whichEnsure },
                    },
                },
                coverages,
            } = store.value.HomeInsurance;
            const coverageDependency = COVERAGES_DEPENDENCY.find(
                dep =>
                    dep.mainCoverage === coverage.code && dep.whichEnsure === whichEnsure
            );
            const deselectAndDisableActions$ = [];
            if (
                !!coverageDependency &&
                coverageDependency.dependentCoverages.length > 0
            ) {
                if (!selected) {
                    deselectAndDisableActions$.push(
                        ...coverageDependency.dependentCoverages.map(code =>
                            of(
                                toggleSelectedCoverage({
                                    coverage: coverages.find(cov => cov.code === code),
                                    selected,
                                })
                            )
                        )
                    );
                }
                deselectAndDisableActions$.push(of(disableDependentCoverages()));
            }
            if (deselectAndDisableActions$.length > 0) {
                return concat(...deselectAndDisableActions$);
            }
            return empty();
        })
    );

const disableDependentCoveragesEpic = (action$, store) =>
    action$.pipe(
        ofType(DISABLE_DEPENDENT_COVERAGES),
        flatMap(() => {
            const {
                personalDataForm: {
                    data: { whichEnsure },
                },
                selectedCoverages,
            } = store.value.HomeInsurance.quotation;
            const selectedCoveragesCodes = selectedCoverages.map(cov => cov.code);
            const disabledCoverageCodes = COVERAGES_DEPENDENCY.filter(
                dep =>
                    dep.whichEnsure === whichEnsure &&
                    !selectedCoveragesCodes.includes(dep.mainCoverage)
            )
                .map(dep => dep.dependentCoverages)
                .reduce((prev, curr) => [...prev, ...curr], []);
            return of(disableDependentCoveragesDone(disabledCoverageCodes));
        })
    );

const loadChannelEpic = (action$, store) =>
    action$.pipe(
        ofType(LOAD_CHANNEL),
        switchMap(({ payload }) => {
            if (!payload.isDefault)
                return ChannelApi.get(payload.partner).pipe(
                    flatMap(({ response }) =>
                        concat(
                            of(loadDefaultChannelDone()),
                            of(loadChannelDone({ response, form: payload }))
                        )
                    ),
                    catchError(err =>
                        concat(
                            of(loadChannelDone(err)),
                            of(
                                navigateTo(
                                    getPathWithPartner(
                                        ROUTES.HOME_INSURANCE.LANDING,
                                        store.value.HomeInsurance.channel.partner,
                                        store.value.HomeInsurance.channel.partnerType
                                    )
                                )
                            ),
                            of(loadDefaultChannelDone())
                        )
                    )
                );
            return of(loadDefaultChannelDone());
        })
    );

const autoSelectCoveragesByMinPrimeEpic$ = (action$, store) =>
    action$.pipe(
        ofType(VALIDATE_MIN_PRIME),
        flatMap(() => {
            const {
                coverages,
                quotation: {
                    personalDataForm: {
                        data: { whichEnsure },
                    },
                    guessPriceForm: {
                        data: { housingValue, assetValue },
                    },
                    propertyInsuranceHasMinPrime,
                },
            } = store.value.HomeInsurance;
            if (whichEnsure === WHICHENSURE_TYPES.HOUSING) {
                const housingValueTier = getTierForHousingValue(housingValue);
                if (housingValueTier === 1) {
                    return concat(
                        ...coverages.map(cov =>
                            of(
                                toggleSelectedCoverage({
                                    coverage: cov,
                                    selected: true,
                                })
                            )
                        ),
                        of(toggleAssistantPackage({ selected: true }))
                    );
                }
            }
            if (whichEnsure === WHICHENSURE_TYPES.ASSETS) {
                const assetsValueTier = getTierForAssetsValue(assetValue);
                if (assetsValueTier === 1) {
                    const disastersCoverage = coverages.find(
                        cov => cov.code === COVERAGES_CODES.NATURAL_DISASTER
                    );
                    return concat(
                        of(
                            toggleSelectedCoverage({
                                coverage: disastersCoverage,
                                selected: true,
                            })
                        ),
                        of(toggleAssistantPackage({ selected: true }))
                    );
                }
            }
            if (whichEnsure === WHICHENSURE_TYPES.HOUSING_ASSETS) {
                if (propertyInsuranceHasMinPrime) {
                    return concat(
                        ...coverages
                            .filter(
                                cov =>
                                    cov.code !== COVERAGES_CODES.ROBBERY &&
                                    cov.code !== COVERAGES_CODES.DISAPPEAR &&
                                    cov.code !== COVERAGES_CODES.THEFT_ESPECIAL &&
                                    cov.code !== COVERAGES_CODES.DISHONESTY
                            )
                            .map(cov =>
                                of(
                                    toggleSelectedCoverage({
                                        coverage: cov,
                                        selected: true,
                                    })
                                )
                            ),
                        of(toggleAssistantPackage({ selected: true }))
                    );
                }
            }
            return EMPTY;
        })
    );

const validateIfDocumentNumberExistsEpic$ = action$ =>
    action$.pipe(
        ofType(VALIDATE_IF_DOCUMENT_NUMBER_EXISTS),
        switchMap(() => of(validateIfDocumentNumberExistsDone(false)))
    );

const sendCrmOracleGetCustomerEpic$ = action$ =>
    action$.pipe(
        ofType(SEND_CRM_ORACLE_GET_CUSTOMER),
        switchMap(({ payload: { documentNumber, documentType } }) =>
            CrmOracleApi.getCustomer(
                documentNumber,
                documentType,
                Auth.getAuthorization()
            ).pipe(
                map(({ response }) => updateCrmOracle(response.partyId)),
                catchError(() => EMPTY)
            )
        )
    );
const sendCrmOracleCreateCustomerEpic$ = (action$, store) =>
    action$.pipe(
        ofType(SEND_CRM_ORACLE_CREATE_CUSTOMER),
        switchMap(({ payload }) => {
            const { email, documentNumber, documentType, cellphone } = payload;
            const { names } = payload;
            const surname = payload.firstSurname;
            const secondLastName = payload.lastSurname;

            return CrmOracleApi.createCustomer(
                new CreateCustomerCrmOracle({
                    names,
                    surname,
                    secondLastName,
                    documentType,
                    numDocument: documentNumber,
                    cellphone,
                    email,
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(({ response }) =>
                    concat(
                        of(updateCrmOracle(response.PartyId)),
                        of(sendCrmOracleCreateOpportunity(payload))
                    )
                ),

                catchError(() => EMPTY)
            );
        })
    );
const sendCrmOracleCreateOpportunityEpic$ = (action$, store) =>
    action$.pipe(
        ofType(SEND_CRM_ORACLE_CREATE_OPPORTUNITY),
        switchMap(({ payload }) => {
            const { partyId } = store.value.HomeInsurance.crmOracle;

            const {
                Page: {
                    history: {
                        location: { pathname },
                    },
                },
            } = store.value;

            const {
                email,
                documentNumber,
                documentType,
                cellphone,
                clientType,
                whichEnsure,
                housingType,
            } = payload;
            const { names } = payload;
            const surname = payload.firstSurname;
            const secondLastName = payload.lastSurname;

            return CrmOracleApi.createOportunnity(
                new CreateOpportunityCrmOracle({
                    partyId,
                    channel: "EC", // CrmOracleApi.validateChannel(partner),
                    names,
                    surname,
                    secondLastName,
                    email,
                    tECId_c: "b7e65c5c-7780-4a59-90bf-11455f29944e",
                    tECFrom_c: pathname,
                    numDocument: documentNumber,
                    documentType: getIdDocumentType(documentType),
                    cellphone,
                    clientType: clientTypeTranslate(clientType),
                    whichEnsure: ensureTranslate(whichEnsure),
                    housingType: housingTypeTranslate(housingType),
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(({ response }) => {
                    window.dynatraceParams = {
                        userDocument: `${documentType}-${documentNumber}`,
                    };
                    Datalayer.setTransactionId(response.OptyNumber);
                    return concat(
                        of(updateCrmOracleOptyNumber(response.OptyNumber)),
                        of(
                            navigateTo(
                                getPathWithPartner(
                                    ROUTES.HOME_INSURANCE.THANKS,
                                    store.value.HomeInsurance.channel.partner,
                                    store.value.HomeInsurance.channel.partnerType
                                )
                            )
                        ),
                        of(closeQuotePopup())
                    );
                }),
                catchError(() => EMPTY)
            );
        })
    );
const sendCrmOracleUpdateInitialDataPhaseEpic$ = (action$, store) =>
    action$.pipe(
        ofType(UPDATE_CRM_ORACLE_INITIAL_DATA),
        switchMap(({ payload }) => {
            const { optyNumber } = store.value.HomeInsurance.crmOracle;
            const {
                info: { fase, distrito, provincia, departamento, metros },
            } = payload;

            return CrmOracleApi.updatePhase(
                optyNumber,
                new UpdateInitialDataPhase({
                    chECFase_c: fase,
                    tPerDistrito_c: distrito,
                    tPerProvincia_c: provincia,
                    tPerDepartamento_c: departamento,
                    nHogarMetros_c: metros,
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(() => of(updateCrmDone())),
                catchError(() => EMPTY)
            );
        })
    );
const sendCrmOracleUpdateQuotePhaseEpic$ = (action$, store) =>
    action$.pipe(
        ofType(UPDATE_CRM_ORACLE_QUOTE),
        switchMap(({ payload }) => {
            const { optyNumber } = store.value.HomeInsurance.crmOracle;
            const {
                info: { fase, valorBien, valorInmueble, fechaInicio },
            } = payload;
            return CrmOracleApi.updatePhase(
                optyNumber,
                new UpdateQuotePhase({
                    chECFase_c: fase,
                    cHogarValorBienes_c: valorBien,
                    cHogarValorInmueble_c: valorInmueble,
                    dECInicio_c: formatDateToCrmOracle(fechaInicio),
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(() => of(updateCrmDone())),
                catchError(() => EMPTY)
            );
        })
    );

const sendCrmOracleUpdateDataPhaseEpic$ = (action$, store) =>
    action$.pipe(
        ofType(UPDATE_CRM_ORACLE_DATA),
        switchMap(({ payload }) => {
            const { optyNumber } = store.value.HomeInsurance.crmOracle;
            const {
                info: {
                    fase,
                    anios,
                    numeroPisos,
                    numeroSotanos,
                    material,
                    direccion,
                    dpto,
                },
            } = payload;

            return CrmOracleApi.updatePhase(
                optyNumber,
                new UpdateDataPhase({
                    chECFase_c: fase,
                    nHogarAntiguedad_c: anios,
                    nHogarNumPisos_c: numeroPisos,
                    nHogarNumSotanos_c: numeroSotanos,
                    tHogarMaterialConstruccion_c: material,
                    tPerDireccion_c: direccion,
                    tPerInterior_c: dpto,
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(() => of(updateCrmDone())),
                catchError(() => EMPTY)
            );
        })
    );

const sendCrmOracleUpdatePaymentPhaseEpic$ = (action$, store) =>
    action$.pipe(
        ofType(UPDATE_CRM_ORACLE_PAYMENT),
        switchMap(({ payload }) => {
            const { optyNumber } = store.value.HomeInsurance.crmOracle;
            const {
                info: { fase },
            } = payload;
            return CrmOracleApi.updatePhase(
                optyNumber,
                new UpdatePaymentPhase({
                    chECFase_c: fase,
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(() => concat(of(updateCrmDone()))),
                catchError(() => EMPTY)
            );
        })
    );

const sendCrmOracleUpdateEndPhaseEpic$ = (action$, store) =>
    action$.pipe(
        ofType(UPDATE_CRM_ORACLE_END),
        switchMap(({ payload }) => {
            const { optyNumber } = store.value.HomeInsurance.crmOracle;
            const {
                info: { fase, poliza },
            } = payload;

            return CrmOracleApi.updatePhase(
                optyNumber,
                new UpdateEndPhase({
                    chECFase_c: fase,
                    tECNumPoliza_c: poliza,
                }),
                Auth.getAuthorization()
            ).pipe(
                flatMap(() => concat(of(updateCrmDone()))),
                catchError(() => EMPTY)
            );
        })
    );

export default function homeInsuranceEpics(action$, store) {
    return merge(
        initializeQuotationFlowEpic(action$, store),
        nextStepEpic(action$, store),
        savePersonalDataEpic(action$),
        saveHousingInfoEpic(action$, store),
        saveInitialHouseInformationEpic(action$),
        saveGuessPriceEpic$(action$, store),
        saveSelectedPlanEpic$(action$, store),
        loadUbigeosEpic(action$, store),
        addRecommendedCoveragesEpic(action$, store),
        calculatePriceEpic(action$, store),
        calculateHomePriceEpic(action$),
        seeMoreInLandingEpic(action$),
        startQuoteProcessEpic$(action$, store),
        deselectDependentCoveragesEpic(action$, store),
        disableDependentCoveragesEpic(action$, store),
        autoSelectCoveragesByMinPrimeEpic$(action$, store),
        loadChannelEpic(action$, store),
        sendZohoEpic(action$, store),
        validateIfDocumentNumberExistsEpic$(action$),
        sendCrmOracleGetCustomerEpic$(action$),
        sendCrmOracleCreateCustomerEpic$(action$, store),
        sendCrmOracleCreateOpportunityEpic$(action$, store),
        sendCrmOracleUpdateInitialDataPhaseEpic$(action$, store),
        sendCrmOracleUpdateQuotePhaseEpic$(action$, store),
        sendCrmOracleUpdateDataPhaseEpic$(action$, store),
        sendCrmOracleUpdatePaymentPhaseEpic$(action$, store),
        sendCrmOracleUpdateEndPhaseEpic$(action$, store)
    );
}
